<template>
  <footer class="my-4 ml-1">
    <p>
      <a href="/terms">Terms and Conditions</a>
      &middot;
      <a href="/privacy">Privacy Policy</a>
    </p>
    <p>&copy; {{ year }} iSimulate</p>
  </footer>
</template>

<script>
export default {
  data: function() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
  font-size: 0.8rem;
}
p > a {
  text-decoration: none;
  color: inherit;
}
</style>
